export default __webpack_public_path__ + "static/media/dao-img.c174ea13.png";